import classNames from 'classnames';
import { toNumberString } from '@client/toolkit';

export const RankedList = ({
  title,
  data,
  unit,
  lowestFirst = false,
  emptyText,
}: {
  title: string;
  data: { id: string; label: string; value: number }[];
  unit: string;
  lowestFirst: boolean;
  emptyText?: string;
}) => {
  return (
    <ul className="grow" data-testid="ranked-list">
      <li className="text-sm text-gray-300 px-2 pb-4 pt-2">{title}</li>
      {data.length === 0 && emptyText && (
        <li className="flex border-t border-border px-2">
          <span className="text-sm text-gray-400 pl-0 pr-2 py-2">{emptyText}</span>
        </li>
      )}
      {data.map((item, i) => (
        <li
          key={`${lowestFirst ? 'lowest' : 'highest'}-${item.id}`}
          className="flex justify-between border-t border-border px-2"
        >
          <span className="text-white text-sm pl-0 pr-2 py-2">{item.label} </span>
          <span
            className={classNames(
              'text-sm pl-2 pr-0 py-2 text-nowrap self-center',
              lowestFirst ? (i === 0 ? 'text-negative' : 'text-[#FFB868]') : 'text-positive',
            )}
          >
            {toNumberString(item.value)}
            {unit}
          </span>
        </li>
      ))}
    </ul>
  );
};
